var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160709",
    "data-name": "Group 160709",
    transform: "translate(-374 -545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 18,
    height: 18,
    transform: "translate(374 545)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M14.371,5.15l1.088-.4a.991.991,0,0,1,1.227.434L17.848,7.2a.986.986,0,0,1-.229,1.276l-.9.745a1.062,1.062,0,0,0-.385.884v.229a1.137,1.137,0,0,0,.385.884l.9.745a1,1,0,0,1,.229,1.276l-1.162,2.021a1.013,1.013,0,0,1-1.227.434l-1.088-.4a1.117,1.117,0,0,0-.965.106.7.7,0,0,1-.2.106,1.139,1.139,0,0,0-.573.777l-.188,1.145a.994.994,0,0,1-.99.835H9.118a1,1,0,0,1-.99-.835L7.94,16.285a1.139,1.139,0,0,0-.573-.777c-.065-.033-.139-.082-.2-.106A1.114,1.114,0,0,0,6.2,15.3l-1.088.4a.991.991,0,0,1-1.227-.434L2.72,13.242a1,1,0,0,1,.229-1.276l.9-.745a1.062,1.062,0,0,0,.385-.884v-.229a1.137,1.137,0,0,0-.385-.884l-.9-.745A1.017,1.017,0,0,1,2.711,7.2L3.873,5.183A1.013,1.013,0,0,1,5.1,4.749l1.088.4a1.117,1.117,0,0,0,.965-.106.7.7,0,0,1,.2-.106,1.139,1.139,0,0,0,.573-.777L8.12,3.031V3.015a.994.994,0,0,1,.99-.835h2.332a1,1,0,0,1,.99.835l.057.344",
    transform: "translate(372.712 543.785)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M14.087,11.394A2.684,2.684,0,1,1,11.4,8.71h0a2.671,2.671,0,0,1,2.684,2.667v.016Z",
    transform: "translate(371.596 542.598)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 0.466,
    cy: 0.466,
    r: 0.466,
    transform: "translate(385.217 548.027)",
    fill: "#165cf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDarkIcon);
export default __webpack_public_path__ + "static/media/settings-dark-icon.487f32c0f305a5d24b5c5311e3d26020.svg";
export { ForwardRef as ReactComponent };